import { Link, useLocation } from "react-router-dom";
import { useSession } from "@/context/SessionContext";
import { productImageUrl } from "@/lib/api";
import { withMarketPath } from "@/lib/marketRoutes";

export default function HomeCampaignBadge() {
  const { pathname } = useLocation();
  const { campaignBadgeVisible, content } = useSession();
  const image = productImageUrl(content?.discount_25_image);

  if (!campaignBadgeVisible || !image) return null;

  return (
    <Link
      to={withMarketPath(pathname, "/produkter/invictusa-25l-tromle")}
      data-testid="home-campaign-discount-badge"
      aria-label="25% discount on InvictusA 25L drum"
      className="fixed bottom-4 right-2 z-[55] block w-14 sm:bottom-6 sm:right-6 sm:w-28 transition-transform hover:-translate-y-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-blue"
    >
      <img src={image} alt="25% discount" className="discount-badge-glow w-full" />
    </Link>
  );
}